import { YinzCamCardsServiceSource } from "yinzcam-cards";
import { Writable } from "svelte/store";

export interface CardsDataSourceRegistration {  
  sourceId: string,
  sequenceId: string,
  store: Writable<any>,
  elementId?: string,
  spec?: YinzCamCardsServiceSource,
  refresh: () => void
}
